import i18n from 'i18next'
import { initializeI18n } from '@infra/application-shell'
import { i18nextConfig } from './i18next'

const version = 'latest'

initializeI18n(i18nextConfig, { en: version, es: version }, version)

export { i18n }
